import { useMemo } from "react";
import {
  InternalAdminDistributionGroupListInput,
  InternalAdminDistributionGroupListQuery,
  InternalAdminDistributionGroupListQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_DISTRIBUTION_GROUP_LIST_QUERY from "../_networking/internal-admin-distribution-group-list";

interface IProps {
  organizationId?: string;
  input: InternalAdminDistributionGroupListInput;
}

const useInternalAdminDistributionGroupList = ({
  organizationId,
  input,
}: IProps) => {
  const { data, loading, refetch } = useQuery<
    InternalAdminDistributionGroupListQuery,
    InternalAdminDistributionGroupListQueryVariables
  >(INTERNAL_ADMIN_DISTRIBUTION_GROUP_LIST_QUERY, {
    fetchPolicy: "network-only",
    variables: organizationId
      ? {
          organizationId,
          input,
        }
      : undefined,
    skip: !organizationId,
  });

  const distributionGroups = useMemo(() => {
    if (!data) return [];
    return data.internalAdminDistributionGroupList;
  }, [data]);

  return {
    distributionGroups,
    loading,
    refetch,
  };
};

export default useInternalAdminDistributionGroupList;
